import DatabaseModel from './DatabaseModel.js';

var TipoDocumento = Object.create(DatabaseModel);

TipoDocumento.model = 'tipodocumento';

export default TipoDocumento;